import { render, staticRenderFns } from "./ptuapp.vue?vue&type=template&id=fbabc2d2&scoped=true&"
import script from "./ptuapp.vue?vue&type=script&lang=js&"
export * from "./ptuapp.vue?vue&type=script&lang=js&"
import style0 from "./ptuapp.vue?vue&type=style&index=0&id=fbabc2d2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbabc2d2",
  null
  
)

export default component.exports